/* The free MBA Tools Workbook in the cart (16 Oct 2026). snippets/bd-workbook-cart.liquid writes the settings
   (script[data-bd-wb-cart-config]) and loads this file with defer, so these 20 KB are no longer inline at the top of
   every page (SPEED-11). It still runs before bd-bundle-app.js (also deferred, further down the page), so the cart
   guard keeps wrapping fetch outside this file's wrapper, as before. How it works: see the snippet's comment. */
(function () {
  if (window.BizDecksWorkbookCart) return;
  var cfgEl = document.querySelector('script[data-bd-wb-cart-config]'), CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  CFG.variant = String(CFG.variant).trim();
  CFG.handles = (CFG.handles || []).map(function (h) { return String(h).trim(); });
  var KEY = 'bd-wb-cart-v2';              // session state: '' | 'declined' | 'nofree@<time>' (v2: the test flags of 16 Oct are gone)
  var NOFREE_MS = 10 * 60 * 1000;
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null, busy = false, again = false, lastCart = null, repairs = 0;

  function state() {
    var v = '';
    try { v = sessionStorage.getItem(KEY) || ''; } catch (e) {}
    // "not free" only holds for a while, so the Workbook comes back by itself once the discount works again
    if (v.indexOf('nofree') === 0 && !(Date.now() - Number(v.split('@')[1] || 0) < NOFREE_MS)) return '';
    return v;
  }
  function setState(v) { try { sessionStorage.setItem(KEY, v); } catch (e) {} }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  // CUR-01 (20 Oct 2026): the subtotal in the visitor's own currency (a UK cart showed "€102,00" next to "£102.00")
  var LOCALES = { GBP: 'en-GB', USD: 'en-US', CAD: 'en-CA', AUD: 'en-AU', NZD: 'en-NZ', CHF: 'de-CH', NOK: 'nb-NO',
    SEK: 'sv-SE', DKK: 'da-DK', PLN: 'pl-PL', CZK: 'cs-CZ', HUF: 'hu-HU', RON: 'ro-RO', JPY: 'ja-JP' };
  function money(cents, currency) {
    var v = Number(cents || 0) / 100;
    var c = String(currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR').toUpperCase();
    // AUDIT-25 (25 Oct 2026, owner OK): no trailing zeros (€119, not €119,00), the same as money_without_trailing_zeros in the cart
    var dec = Math.round(v * 100) % 100 === 0 ? 0 : 2;
    if (c === 'EUR') return '€' + v.toLocaleString('nl-NL', { minimumFractionDigits: dec, maximumFractionDigits: 2 });
    try { return new Intl.NumberFormat(LOCALES[c] || 'en-GB', { style: 'currency', currency: c, minimumFractionDigits: dec, maximumFractionDigits: dec ? 2 : 0 }).format(v); } catch (e) {}
    return c + ' ' + v.toFixed(2);
  }
  /* the theme's cart guard checks the whole cart after every change it lets through, and hangs that cart on the
     response (bdCartValidation): it is kept as data.bdCart, so no extra read is needed */
  function call(path, body) {
    if (!body && path === 'cart.js' && window.BizDecksCartSupport?.ready('readCart')) return window.BizDecksCart.readCart();
    var request = window.BizDecksCartSupport?.request || window.fetch;
    return request(root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-BD-WB': '1' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      var checked = r.bdCartValidation && r.bdCartValidation.cart;
      return r.json().then(function (data) {
        if (data && typeof data === 'object' && checked && Array.isArray(checked.items)) data.bdCart = checked;
        return data;
      });
    });
  }
  function isWorkbook(item) { return String(item.variant_id) === CFG.variant; }
  function isAuto(item) { return isWorkbook(item) && item.properties && item.properties._bd_wb_free; }
  function hasToolkit(cart) { return cart.items.some(function (i) { return CFG.handles.indexOf(i.handle) !== -1; }); }
  // AUDIT-25 (25 Oct 2026): the toolkit variants in the cart, so a "not free" marker only holds for the toolkit it was set for
  function kitSig(cart) { return cart.items.filter(function (i) { return CFG.handles.indexOf(i.handle) !== -1; }).map(function (i) { return String(i.variant_id); }).sort().filter(function (v, n, a) { return a.indexOf(v) === n; }).join(','); }

  async function sync() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      var cached = window.BizDecksCart && window.BizDecksCart.peekCart && window.BizDecksCart.peekCart();
      var cart = cached || await call('cart.js'), changed = false, sections = null;
      repairs = 0;
      // a removed or not-free Workbook stays out only while this toolkit is in the cart: the next toolkit tries again
      if (!hasToolkit(cart) && state()) setState('');
      // AUDIT-25: another format (or a marker from before this fix) tries again, so a stale "nofree" never blocks the next add
      var st0 = state(); if (st0.indexOf('nofree') === 0 && st0.split('@')[2] !== kitSig(cart)) setState('');
      if (hasToolkit(cart) && !cart.items.some(isWorkbook) && !CFG.returning && !state()) {
        var added = await call('cart/add.js', { items: [{ id: Number(CFG.variant), quantity: 1, properties: { _bd_wb_free: '1', _bd_package_key: 'workbook' } }], sections: SECTIONS });
        sections = added && added.sections;
        cart = (added && added.bdCart) || await call('cart.js'); changed = true;
      }
      var wb = cart.items.filter(isWorkbook), auto = wb.filter(isAuto), toolkit = hasToolkit(cart);
      var notFree = auto.filter(function (i) { return i.final_line_price > 0; });
      if (notFree.length && sections) {
        // just added: give the discount one more moment before deciding
        await wait(800);
        cart = await call('cart.js');
        wb = cart.items.filter(isWorkbook); auto = wb.filter(isAuto); toolkit = hasToolkit(cart);
        notFree = auto.filter(function (i) { return i.final_line_price > 0; });
      }
      if (notFree.length && toolkit) {
        // the discount does not apply (missing or ended): never charge for the bonus. AUDIT-25: only with a toolkit in
        // the cart; without one the Workbook is just an orphan (deck removed) and the drop below takes it out
        setState('nofree@' + Date.now() + '@' + kitSig(cart));
        console.warn('[BizDecks workbook] the Workbook is not free in the cart, so it was taken out again');
      }
      // a Workbook the customer put in the cart on their own takes the place of the free one
      var drop = !toolkit || notFree.length || wb.length > auto.length ? auto : auto.slice(1), more = false;
      var corrected = null;
      for (var i = 0; i < drop.length; i += 1) { corrected = await call('cart/change.js', { id: drop[i].key, quantity: 0 }); more = true; }
      if (!drop.length && auto.length && auto[0].quantity !== 1) { corrected = await call('cart/change.js', { id: auto[0].key, quantity: 1 }); more = true; }
      if (more) { cart = corrected && Array.isArray(corrected.items) && typeof corrected.item_count === 'number' ? corrected : await call('cart.js'); sections = null; changed = true; }
      lastCart = cart;
      if (changed) {
        // The coordinator updates cart page sections and totals without navigation.
        cart = await refreshDrawer(cart, sections);
        lastCart = cart;
      }
      decorate(cart);
    } catch (e) {
      console.warn('[BizDecks workbook] cart check skipped:', e);
    } finally {
      busy = false;
      if (again) { again = false; schedule(); }
    }
  }
  function inDrawer() { return Boolean(document.querySelector('cart-drawer .cart-item[data-bd-line-key^="' + CFG.variant + ':"]')); }
  /* the add response already holds the new side cart, so it is shown at once; otherwise (or if that did not work)
     the theme's own refresh is used, which skips a call while it is already refreshing: try again until it matches */
  async function refreshDrawer(cart, sections) {
    // Legacy supplied sections can precede a later gift or quantity mutation.
    // Only the coordinator renders current, revision-checked server sections.
    if (window.BizDecksCartSupport?.ready('refresh')) {
      var current = await window.BizDecksCart.refresh({ open: false });
      return current && Array.isArray(current.items) ? current : cart;
    }
    var page = document.querySelector('cart-items');
    if (page && typeof page.getSectionsToRender === 'function' && typeof page.applyRenderedSections === 'function') {
      var names = Array.from(new Set(page.getSectionsToRender().map(function (item) { return item.section; }).filter(Boolean)));
      var request = window.BizDecksCartSupport?.request || window.fetch;
      var response = await request(root + '?sections=' + encodeURIComponent(names.join(',')), {cache:'no-store'});
      if (!response.ok) throw new Error('Cart display could not be refreshed. View the full cart.');
      var fresh = await response.json(), focus = document.activeElement, id = focus && focus.id, x = window.scrollX, y = window.scrollY;
      await page.applyRenderedSections(Object.assign({},cart,{sections:fresh}));
      if (focus && !focus.isConnected && id) { var replacement=document.getElementById(id); if(replacement)replacement.focus({preventScroll:true}); }
      window.scrollTo(x,y);
    }
    return cart;
  }
  function schedule(delay) { clearTimeout(timer); timer = setTimeout(sync, delay == null ? 350 : delay); }
  function drawerOpen() {
    var d = document.querySelector('cart-drawer');
    return Boolean(d && (d.classList.contains('active') || d.getAttribute('aria-hidden') === 'false'));
  }

  /* the side cart (and the cart page): the Workbook line "Free" with "Free Workbook added (worth €29)" under it, no
     quantity box. PRICE-01 (17 Oct 2026): no struck-through prices any more, not on the line and not at the subtotal */
  function decorate(cart) {
    if (!cart) return;
    // the discount that makes the Workbook free is shown as "Free" on its line, so its label (which Shopify also
    // puts under the toolkit that qualifies) is left out
    var titles = [];
    cart.items.filter(isWorkbook).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (d) {
        var t = d.discount_application && d.discount_application.title;
        if (t && titles.indexOf(t) === -1) titles.push(t);
      });
    });
    if (titles.length) document.querySelectorAll('.cart-item .discounts li, .cart-item .discounts__discount').forEach(function (li) {
      if (titles.some(function (t) { return li.textContent.indexOf(t) !== -1; })) li.style.display = 'none';
    });
    document.querySelectorAll('.cart-item[data-bd-line-key^="' + CFG.variant + ':"]').forEach(function (row) {
      var name = row.querySelector('.cart-item__name');
      if (name && CFG.title && name.textContent.trim() !== CFG.title) name.textContent = CFG.title;
      var key = row.getAttribute('data-bd-line-key');
      var line = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!line || typeof line.final_line_price !== 'number' || !Number.isFinite(line.final_line_price) || line.final_line_price !== 0 || !(line.original_line_price > 0)) return;
      row.setAttribute('data-bd-wb-free', '');
      var price = row.querySelector('.item-price-wrapper');
      if (price && !price.querySelector('.bd-wb-cart-free')) {
        price.innerHTML = '<span class="product-option bd-wb-cart-free"><b>' + CFG.free + '</b></span>' +
          (CFG.note ? '<span class="bd-wb-cart-note">' + CFG.note + '</span>' : '');
      }
      // the cart page on phones hides that price block: the line "Free Workbook added" then goes under "Free" in the
      // line total (PRICE-01)
      var total = row.querySelector('.cart-item__price-wrapper');
      if (CFG.note && total && !total.querySelector('.bd-wb-cart-note') && !(price && price.offsetParent)) {
        total.insertAdjacentHTML('beforeend', '<span class="bd-wb-cart-note">' + CFG.note + '</span>');
      }
    });
    document.querySelectorAll('.cart-drawer__footer .totals .price-original, .totals .totals__subtotal-value').forEach(function (el) {
      var sig = String(cart.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR') + ':' + String(cart.total_price);
      if (el.getAttribute('data-bd-wb-total') === sig) return;
      el.setAttribute('data-bd-wb-total', sig);
      el.textContent = money(cart.total_price, cart.currency);
    });
    mergeRows();
  }

  /* MERGE-01 (16 Oct 2026, owner): the same product twice shows as ONE line. With the Workbook in the cart the Buy X
     get Y discount makes Shopify split a toolkit line in two (one unit carries the discount), and Shopify splits
     again after any merge. So the side cart and the cart page show such lines as one row with the total quantity
     (the other rows are hidden), and + / - / typing / remove on that row set the total in one /cart/update.js call:
     the line with the discount keeps its unit, the other line takes the rest. Works from the DOM only, so it runs at
     once on every re-render (no flash of two rows). */
  var MERGE_SCOPES = ['cart-drawer', '#main-cart-items'];
  function mergeRows() {
    MERGE_SCOPES.forEach(function (sel) {
      var box = document.querySelector(sel);
      if (!box) return;
      var groups = {}, order = [];
      box.querySelectorAll('.cart-item[data-bd-line-key]').forEach(function (row) {
        var key = row.getAttribute('data-bd-line-key') || '';
        if (!key || key.indexOf(CFG.variant + ':') === 0) return;      // the Workbook keeps its own line
        var props = row.querySelector('.cart-item__details > dl, .cart-item__details dl');
        var g = (row.getAttribute('data-bd-variant-id') || key.split(':')[0]) + '|' + (props ? props.textContent.replace(/\s+/g, ' ').trim() : '');
        if (!groups[g]) { groups[g] = []; order.push(g); }
        groups[g].push(row);
      });
      order.forEach(function (g) {
        var rows = groups[g];
        if (rows.length < 2) return;
        var first = rows[0], total = 0;
        rows.forEach(function (r) {
          var q = Number(r.getAttribute('data-bd-quantity'));
          if (!q) { var i = r.querySelector('input.quantity__input, [data-cart-qty-input]'); q = Number(i && i.getAttribute('value')) || 0; }
          total += q;
        });
        first.setAttribute('data-bd-merged', rows.map(function (r) { return r.getAttribute('data-bd-line-key'); }).join(','));
        first.setAttribute('data-bd-merged-total', String(total));
        rows.slice(1).forEach(function (r) { r.setAttribute('data-bd-merged-away', ''); r.setAttribute('aria-hidden', 'true'); });
        var input = first.querySelector('input.quantity__input, [data-cart-qty-input]');
        if (!input) return;
        var own = Number(first.getAttribute('data-bd-quantity')) || Number(input.getAttribute('value')) || 1;
        var max = (Number(input.getAttribute('max')) || 999999) + total - own;
        input.setAttribute('max', String(max));
        input.setAttribute('value', String(total));
        input.value = String(total);
        [['minus', total <= 0], ['plus', total >= max]].forEach(function (b) {
          var btn = first.querySelector('button[name="' + b[0] + '"]');
          if (!btn) return;
          btn.classList.toggle('disabled', b[1]);
          if (b[1]) btn.setAttribute('disabled', ''); else btn.removeAttribute('disabled');
        });
      });
    });
  }
  function mergedRow(el) { return el && el.closest ? el.closest('.cart-item[data-bd-merged]') : null; }
  var mergeBusy = false;
  async function setMerged(row, q) {
    if (mergeBusy) return;
    mergeBusy = true;
    var keys = (row.getAttribute('data-bd-merged') || '').split(',');
    var overlay = row.querySelector('.loading-overlay');
    if (overlay) overlay.classList.remove('hidden');
    try {
      var cart = await call('cart.js');
      var lines = cart.items.filter(function (i) { return keys.indexOf(i.key) !== -1; });
      if (!lines.length) throw new Error('the lines changed');
      lines.sort(function (a, b) { return (b.line_level_discount_allocations || []).length - (a.line_level_discount_allocations || []).length; });
      var left = q, updates = {};
      lines.forEach(function (l, n) {
        var take = n === lines.length - 1 ? left : Math.min(left, l.quantity);
        updates[l.key] = take;
        left -= take;
      });
      var res = await call('cart/update.js', { updates: updates, sections: SECTIONS });
      var after = (res && res.bdCart) || (res && Array.isArray(res.items) && typeof res.item_count === 'number' ? res : await call('cart.js'));
      lastCart = after;
      // The coordinator updates cart page sections and totals without navigation.
      after = await refreshDrawer(after, res && res.sections);
      lastCart = after;
      decorate(after);
    } catch (e) {
      console.warn('[BizDecks cart] quantity change skipped:', e);
      if (window.BizDecksCartSupport?.ready('reportError')) window.BizDecksCart.reportError(e);
    } finally {
      mergeBusy = false;
      if (overlay) overlay.classList.add('hidden');
      schedule(60);   // the Workbook check: e.g. it leaves with the last toolkit
    }
  }
  /* + / - / remove / typing on a merged row: handled here (capture), before the theme's own handlers */
  document.addEventListener('click', function (e) {
    var row = mergedRow(e.target);
    if (!row) return;
    var btn = e.target.closest('button[name="plus"], button[name="minus"], cart-remove-button, .cart-remove');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var input = row.querySelector('input.quantity__input, [data-cart-qty-input]');
    var cur = Number(input && input.value) || Number(row.getAttribute('data-bd-merged-total')) || 0;
    var max = Number(input && input.getAttribute('max')) || 999999;
    var q = btn.matches('button[name="plus"]') ? Math.min(max, cur + 1) : btn.matches('button[name="minus"]') ? Math.max(0, cur - 1) : 0;   // MIN-0 (20 Oct 2026): minus at 1 removes the line
    if (q !== cur) setMerged(row, q);
  }, true);
  document.addEventListener('input', function (e) {
    if (mergedRow(e.target) && e.target.matches && e.target.matches('input')) e.stopImmediatePropagation();
  }, true);
  document.addEventListener('change', function (e) {
    var row = mergedRow(e.target);
    if (!row || !e.target.matches || !e.target.matches('input')) return;
    e.stopImmediatePropagation();
    var q = parseInt(e.target.value, 10), max = Number(e.target.getAttribute('max')) || 999999;
    if (isNaN(q)) return;
    setMerged(row, Math.max(0, Math.min(max, q)));
  }, true);
  /* the side cart is re-rendered by the theme after every change: decorate the new markup */
  function watch() {
    document.addEventListener('bd:cart:rendered', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart || !Array.isArray(cart.items)) return;
      lastCart = cart;
      decorate(cart);
    });
    // Decoration is local and idempotent. A redraw must never initiate another
    // repair/read loop or reopen a drawer that the visitor closed.
    var observer = new MutationObserver(function () { mergeRows(); });
    var drawer = document.querySelector('cart-drawer');
    [drawer && (drawer.closest('.shopify-section') || drawer.parentNode),
      document.getElementById('main-cart-items')].forEach(function (element) {
      if (element) observer.observe(element, { childList: true, subtree: true });
    });
  }
  /* FAST-01 (16 Oct 2026, owner: the side cart must be fast on mobile): when a toolkit is added with a JSON list of
     items (the Add to cart of the product page) and the cart has no Workbook yet, the Workbook goes along in the
     SAME request, so both lines appear in the side cart at once (it used to follow ~1.4 s later on slow 4G, after
     a second round trip). If that request fails, the real result is shown without repeating the add. Other adds (forms)
     keep the check after the add. */
  var ADD = /\/cart\/add(\.js)?(\?|$)/;
  function withWorkbook(body) {
    if (CFG.returning || state() || !lastCart || lastCart.items.some(isWorkbook)) return null;
    var data;
    try { data = JSON.parse(body); } catch (e) { return null; }
    if (!data || !Array.isArray(data.items) || !data.items.length) return null;
    var toolkit = data.items.some(function (i) {
      var p = (i && i.properties) || {};
      return CFG.handles.indexOf(p._bd_package_key) !== -1 || CFG.handles.indexOf(p._bd_product_handle) !== -1;
    });
    if (!toolkit || data.items.some(function (i) { return i && String(i.id) === CFG.variant; })) return null;
    data.items.push({ id: Number(CFG.variant), quantity: 1, properties: { _bd_wb_free: '1', _bd_package_key: 'workbook' } });
    return JSON.stringify(data);
  }
  /* every cart change the page makes (theme, quick add, sticky bar) triggers a check */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' || input instanceof URL ? String(input) : (input && input.url) || '';
    var h = init && init.headers, mine = h && (typeof h.get === 'function' ? h.get('X-BD-WB') : h['X-BD-WB']);
    var self = this, args = arguments, p;
    var bundled = !mine && ADD.test(url) && init && typeof init.body === 'string' ? withWorkbook(init.body) : null;
    if (bundled) {
      // A failed response does not prove that no item was added. Preserve
      // the real response and reconcile; never silently send a second add.
      p = nativeFetch.call(self, input, Object.assign({}, init, { body: bundled }));
    } else {
      p = nativeFetch.apply(self, args);
    }
    if (!mine && MUTATION.test(url)) p.then(function (r) { if (r && r.ok) schedule(60); }, function () {});
    return p;
  };
  /* removing the free Workbook keeps it removed for this session */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-remove-button[data-bd-line-key^="' + CFG.variant + ':"], .cart-item[data-bd-wb-free] .cart-remove');
    if (b) setState('declined');
  }, true);
  window.BizDecksWorkbookCart = { sync: sync, decorate: function () { decorate(lastCart); }, config: CFG };
  function init() { mergeRows(); watch(); schedule(50); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
